import { modifier } from 'ember-modifier';

export default modifier(function initializeClientType(element, [initializeFunction]) {
  if (initializeFunction) {
    initializeFunction();
  }
});
